import { Box, Typography } from '@mui/material';

import { capitalizeFirstLetter } from '../../../../../../../../../helpers';
import { FORTA_BLUE, FORTA_WHITE } from '../../../../../../../../../utils/colors';

import type { ReactNode } from 'react';
import type { IOption } from '../../../../../../../../../utils/types';

interface ClientOptionProps {
  props: object;
  option: IOption;
}

function ClientOption({ props, option }: ClientOptionProps): ReactNode {
  return (
    <Box
      {...props}
      sx={{ display: 'flex', justifyContent: 'space-between' }}
      key={option.id}
      data-testid={`clientLabel${option.id}`}
    >
      <Typography>{option.label}</Typography>
      {option.description && (
        <Typography
          sx={{
            px: 1,
            ml: 1,
            borderRadius: '4px',
            color: FORTA_WHITE,
            fontWeight: 700,
            backgroundColor: FORTA_BLUE.light1,
          }}
        >
          {capitalizeFirstLetter(option.description)}
        </Typography>
      )}
    </Box>
  );
}

export default ClientOption;
